import BaseCustomGetResponse from "./BaseCustomGetResponse";

class CustomResponseDocumentTask extends BaseCustomGetResponse {
  // default number request relative
  protected defaultNumberRequestRelative: number = 3;
}

export default CustomResponseDocumentTask;
